import {
  put,
  call,
  take,
  takeEvery,
  fork,
  select,
  race
} from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { browserHistory } from 'react-router'
import {
  FETCH_TUTORIAL_LIST,
  FETCH_TUTORIAL_STEPS,
  ANIMATE_STEP,
  ANIMATE_ALL,
  UPDATE_STEP,
  UPDATE_STEP_NB,
  AUTO_STEP
} from './constants'
import { fetchTutorialListApi, fetchTutorialStepsApi } from './services'
import {
  fetchTutorialList,
  fetchTutorialSteps,
  updateStepFrame,
  updateStepNonBlocking,
  termAllStepAnimation,
  autoStep
} from './actions'
import {
  selectAnimationData,
  selectCurrentStep,
  selectButtonData,
  selectIsLastStep
} from './selectors'
import languages from '../../constants/languages'
import { slugify } from '../../helpers/utils'

function* fetchTutorialListWorker(currentPhoneId) {
  const state = yield select()
  const { preSaleFlag } = state.devicebits
  const language = languages[state.devicebits.language]
  const { customer } = state.devicebits
  const response = yield call(
    fetchTutorialListApi,
    currentPhoneId,
    preSaleFlag,
    language,
    customer
  )
  const tutorials = addSlugs(response)

  yield put(fetchTutorialList.success(currentPhoneId, tutorials))
}

const addSlugs = tutResponse => (
  tutResponse.tutorials.map(category => ({
    ...category,
    children: category.children.map(tut => ({
      ...tut,
      slug: slugify(tut.name),
      categorySlug: slugify(tut.tutorialCategoryName),
    }))
  }))
)

function* fetchTutorialStepsWorker(tutorialId) {
  const state = yield select()
  const language = languages[state.devicebits.language]
  const { customer } = state.devicebits
  const response = yield call(
    fetchTutorialStepsApi,
    tutorialId,
    language,
    customer
  )

  // Redirect to parent container when tutorial doesn't have any steps
  if (response.length === 0) {
    browserHistory.push({
      pathname: '/tutorials'
    })
    return
  }

  yield put(fetchTutorialSteps.success(tutorialId, response))
}

function* animateStepWorker(stepDelay = 500) {
  const state = yield select()
  const animationData = selectAnimationData(state)
  yield call(delay, stepDelay)
  // eslint-disable-next-line no-plusplus
  for (let frameIndex = 0; frameIndex < animationData.length; frameIndex++) {
    yield put(updateStepFrame(frameIndex))
    yield call(delay, animationData[frameIndex].delay)
  }
  yield put(updateStepNonBlocking(selectCurrentStep(state) + 1))
}

function* animateAllWorker(stepDelay = 500) {
  const state = yield select()
  if (!selectIsLastStep(state)) {
    yield call(animateStepWorker, stepDelay)
    yield take(AUTO_STEP)
    yield call(animateAllWorker, 2500)
  } else {
    yield put(termAllStepAnimation())
  }
}

function* fetchTutorialListWatcher() {
  while (true) {
    const payload = yield take(FETCH_TUTORIAL_LIST.REQUEST)
    yield call(fetchTutorialListWorker, payload.currentPhoneId)
  }
}

function* fetchTutorialStepsWatcher() {
  while (true) {
    const { tutorialId } = yield take(FETCH_TUTORIAL_STEPS.REQUEST)
    yield call(fetchTutorialStepsWorker, tutorialId)
  }
}

function* animateStepWatcher() {
  yield takeEvery(ANIMATE_STEP, function* animateStep() {
    yield race({
      task: call(animateStepWorker),
      cancel1: take(UPDATE_STEP),
      cancel2: take(FETCH_TUTORIAL_STEPS.REQUEST)
    })
  })
}

function* animateStepHelper() {
  yield takeEvery(UPDATE_STEP_NB, function* animateStepActions() {
    const state = yield select()
    if (
      selectButtonData(state).swipeOrAction.toLowerCase() === 'none' &&
      !selectIsLastStep(state)
    ) {
      yield race({
        task: call(animateStepWorker, 300),
        cancel1: take(UPDATE_STEP),
        cancel2: take(FETCH_TUTORIAL_STEPS.REQUEST)
      })
    } else {
      yield put(autoStep())
    }
  })
}

function* animateAllWatcher() {
  while (true) {
    yield take(ANIMATE_ALL)
    yield race({
      task: call(animateAllWorker),
      cancel1: take(UPDATE_STEP),
      cancel2: take(FETCH_TUTORIAL_STEPS.REQUEST)
    })
  }
}

export default function* rootSaga() {
  yield fork(fetchTutorialListWatcher)
  yield fork(fetchTutorialStepsWatcher)
  yield fork(animateStepWatcher)
  yield fork(animateStepHelper)
  yield fork(animateAllWatcher)
}



// WEBPACK FOOTER //
// ./src/containers/Tutorials/sagas.js